import { Search } from '@styled-icons/bootstrap/Search';
import { CompetitionListSchema } from '@/views/sports/components/CompetitionList/styles/CompetitionList.styles';

export const competitionListStyles: CompetitionListSchema = {
  skeleton: {
    startColor: 'alpha.100',
    endColor: 'alpha.200',
    minW: 'full',
    h: '20',
    borderRadius: 'lg',
    flex: 1,
    mt: '8',
  },
  input: {
    name: 'x',
    sxWrapper: { mb: '0' },
    border: '1px',
    boxShadow: '0px 1px 0px 0px rgba(255, 255, 255, 0.05)',
    borderRadius: 'md',
    color: 'white',
    mb: '0',
    _hover: {
      '&&': {
        bg: 'blackAlpha.600',
        _placeholder: {
          color: 'gray.400',
        },
      },
      color: 'white',
    },
    _focus: {
      '&&': {
        bg: 'blackAlpha.600',
        _placeholder: {
          color: 'gray.400',
        },
      },
      color: 'white',
      textShadow: 'sm',
    },
    _placeholder: {
      color: 'whiteAlpha.500',
      fontWeight: 'bold',
      fontSize: '2xs',
    },
    sx: {
      '&&': {
        bg: 'blackAlpha.600',
        _placeholder: {
          color: 'whiteAlpha.400',
        },
      },
    },
  },
  inputRightIcon: {
    color: 'alpha.400',
    boxSize: '4',
    as: Search,
  },
  accordion: {
    color: 'white',
    mb: '3',
    variant: 'unstyled',
    w: 'full',
  },
  accordionItem: {
    outline: 'none',
    border: 'none',
    py: '2',
  },
  accordionButton: {
    px: '0',
    pos: 'relative',
    _hover: { bg: 'transparent' },
  },
  hStack: {
    w: 'full',
    alignItems: 'center',
  },
  flex: { alignItems: 'center', gap: 2, flex: 1, textAlign: 'left' },
  accordionButtonIconSvg: {
    color: 'alpha.600',
    fontSize: 'md',
  },
  accordionButtonText: {
    fontSize: ['sm', 'md'],
    fontWeight: 'bold',
    color: 'beta.300',
    fontFamily: 'Fraunces',
    textTransform: 'capitalize',
    textShadow: '0px 3px 4px rgba(0, 0, 0, 0.25)',
  },
  marketTypesFlex: {
    mr: '2',
    gap: '2',
  },
  marketTypesText: {
    w: ['50px', '100px'],
    fontSize: '2xs',
    fontWeight: 'bold',
    color: 'white',
  },
  accordionButtonInnerIcon: {
    pos: 'absolute',
    right: '0',
    boxSize: '6',
    color: 'white',
  },
  accordionPanel: {
    p: '0',
    mb: '3',
  },
};
